
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cases/pdm-pmm/page/[id]",
      function () {
        return require("private-next-pages/cases/pdm-pmm/page/[id].tsx");
      }
    ]);
  